import { render, staticRenderFns } from "./MakeReview.vue?vue&type=template&id=0e875112&scoped=true"
import script from "./MakeReview.vue?vue&type=script&lang=js"
export * from "./MakeReview.vue?vue&type=script&lang=js"
import style0 from "./MakeReview.vue?vue&type=style&index=0&id=0e875112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e875112",
  null
  
)

export default component.exports